(function (w) {
  'use strict';
  var original = ['Core Black', 'Cream Brown', 'Cloud White', 'Earth Strata'];
  var second = ['Metallic Silver', 'Cow Print', 'CDG', 'Red Leopard'];
  function color(value) { return value === 'Metalic Silver' ? 'Metallic Silver' : value; }
  function isColor(name) { return /^(colors?|colours?|cor|couleur)$/i.test(name); }
  function colors(group) { return (group === 'v2' ? second : original).slice(); }
  function product(source, group, initial) {
    var allowed = colors(group), first = color(initial);
    var edges = source.variants.edges.filter(function (edge) {
      return edge.node.selectedOptions.some(function (o) { return isColor(o.name) && allowed.indexOf(color(o.value)) >= 0; });
    }).map(function (edge) {
      return {node: Object.assign({}, edge.node, {selectedOptions: edge.node.selectedOptions.map(function (o) {
        return isColor(o.name) ? Object.assign({}, o, {value: color(o.value)}) : o;
      })})};
    });
    if (!edges.length) throw new Error('No variants in this palette');
    if (first && allowed.indexOf(first) >= 0) edges.sort(function (a,b) {
      function preferred(edge) { return edge.node.selectedOptions.some(function (o) { return isColor(o.name) && o.value === first; }) ? 0 : 1; }
      return preferred(a)-preferred(b);
    });
    return Object.assign({}, source, {options: source.options.map(function (o) {
      return isColor(o.name) ? Object.assign({}, o, {values: allowed.filter(function (c) { return edges.some(function (edge) { return edge.node.selectedOptions.some(function (v) { return isColor(v.name) && v.value === c; }); }); })}) : o;
    }), variants:{edges:edges}});
  }
  function compare(single) { return Math.round(single / 0.7); }
  function totals(prices) {
    if (!prices.length || !prices.every(function (p) { return Number.isSafeInteger(p) && p > 0; })) return null;
    return prices.length === 1 ? {total:prices[0],compare:compare(prices[0])} :
      {total:prices[0]+Math.round(prices[1]/2),compare:prices[0]+prices[1]};
  }
  w.SambaPaletteOffers = {color:color,colors:colors,product:product,compare:compare,totals:totals};
})(window);
